import FW from '../fw/fw';
import Env from '../fw/env';
import Logger from '../fw/logger';


export default class AdsHelpers {

  #rmp;
  #onInteractionReloadAdTagFn = null;
  #adCountdownInterval = null;
  #adRemainingTimeBarInterval = null;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  static tcfapi() {
    // __tcfapi for ads https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/TCFv2/IAB Tech Lab - CMP API v2.md
    if (typeof window.__tcfapi !== 'undefined') {
      const callback = (tcData, success) => {
        if (success && tcData && typeof tcData.gdprApplies === 'boolean' && tcData.gdprApplies) {
          window.rmpGlobals.TCFv2.gdprApplies = '1';
          if ((tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete') && typeof tcData.tcString === 'string' && tcData.tcString !== '') {
            window.rmpGlobals.TCFv2.tcString = tcData.tcString;
            Logger.print('info', '__tcfapi gdprApplies: ' + window.rmpGlobals.TCFv2.gdprApplies);
            Logger.print('info', '__tcfapi tcString available: ' + window.rmpGlobals.TCFv2.tcString);
            window.__tcfapi('removeEventListener', 2, success => {
              if (success) {
                Logger.print('info', '__tcfapi removeEventListener completed ' + tcData.listenerId);
              }
            }, tcData.listenerId);
          }
        } else {
          Logger.print('info', '__tcfapi gdprApplies: ' + window.rmpGlobals.TCFv2.gdprApplies);
        }
      };
      window.__tcfapi('addEventListener', 2, callback);
    }
  }

  static uspapi() {
    // https://github.com/InteractiveAdvertisingBureau/CCPA-reference-code
    // https://github.com/InteractiveAdvertisingBureau/USPrivacy
    if (typeof window.__uspapi !== 'undefined') {
      window.__uspapi('getUSPData', 1, (consent, success) => {
        Logger.print('info', 'getUSPData success: ' + success);
        if (success && consent && consent.uspString) {
          Logger.print('info', '__uspapi string is: ' + consent.uspString.toUpperCase());
          window.rmpGlobals.USPData = consent.uspString.toUpperCase();
        }
      });
    }
  }

  static rfc3986EncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, (c) => {
      return '%' + c.charCodeAt(0).toString(16);
    });
  }

  static getOmidAccessModeRules(inputOmidAccessModeRules) {
    const omidAccessModeRules = {};
    const keys = Object.keys(inputOmidAccessModeRules);
    for (let i = 0, len = keys.length; i < len; i++) {
      const key = keys[i];
      if (google.ima.OmidVerificationVendor[key]) {
        switch (inputOmidAccessModeRules[key]) {
          case 'LIMITED':
            omidAccessModeRules[google.ima.OmidVerificationVendor[key]] = google.ima.OmidAccessMode.LIMITED;
            break;
          case 'DOMAIN':
            omidAccessModeRules[google.ima.OmidVerificationVendor[key]] = google.ima.OmidAccessMode.DOMAIN;
            break;
          case 'FULL':
            omidAccessModeRules[google.ima.OmidVerificationVendor[key]] = google.ima.OmidAccessMode.FULL;
            break;
          default:
            break;
        }
      }
    }
    Logger.print('google-ima', 'omidAccessModeRules follow', omidAccessModeRules);
    return omidAccessModeRules;
  }

  static isGoogleImaDaiAvailable() {
    return typeof google !== 'undefined' && typeof google.ima !== 'undefined' && typeof google.ima.dai !== 'undefined';
  }

  #onAdLoadedAfterReload() {
    if (this.#rmp.isMobile) {
      this.#rmp.dom.centralMobileUI.classList.remove('rmp-mobile-show-play');
      this.#rmp.dom.centralMobileUIIcon.classList.remove('rmp-i-replay');
      this.#rmp.dom.centralMobileUIIcon.classList.add('rmp-i-pause');
    } else {
      this.#rmp.dom.overlayButtonIcon.classList.replace('rmp-i-replay', 'rmp-i-play');
    }
  }

  #handleFullSlotAdSense() {
    const adsensePattern = /adsense/i;
    const contentTypePattern = /(text|image\/)/i;
    if (adsensePattern.test(this.#rmp.adSystem) && contentTypePattern.test(this.#rmp.adContentType)) {
      Logger.print('ima', 'full slot adsense video ad detected - hide UI');
      this.#rmp.dom.container.classList.add('rmp-ad-no-ui');
    }
  }

  #setVPAIDUI(boolean) {
    Logger.print('advertisement', '#setVPAIDUI to ' + boolean);
    if (boolean) {
      if (this.#rmp.adVpaidControls) {
        this.#rmp.dom.container.classList.add('rmp-ad-vpaid-force-controls');
      } else {
        this.#rmp.dom.container.classList.add('rmp-ad-no-ui');
      }
    } else {
      if (this.#rmp.adVpaidControls) {
        this.#rmp.dom.container.classList.remove('rmp-ad-vpaid-force-controls');
      } else {
        this.#rmp.dom.container.classList.remove('rmp-ad-no-ui');
      }
    }
  }

  #onInteractionReloadAdTag(event) {
    Logger.print('outstream', 'attempt to reload adTag due to adTagReloadOnEnded setting');
    FW.eventStopPrevent(event);
    if (this.#rmp.dom.controlBar) {
      this.#rmp.dom.controlBar.classList.remove('rmp-no-display');
    }
    if (this.#rmp.isMobile) {
      FW.removeEvents(['touchend', 'click'], this.#rmp.dom.centralMobileUI, this.#onInteractionReloadAdTagFn);
    } else {
      FW.removeEvents(['touchend', 'click'], this.#rmp.dom.overlayButton, this.#onInteractionReloadAdTagFn);
      this.#rmp.dom.container.removeEventListener('click', this.#onInteractionReloadAdTagFn);
    }
    this.#rmp.adTagWaterfall = [...this.#rmp.rmpInitManagement.originalAdTagWaterfall];
    this.#rmp.adTagUrl = this.#rmp.rmpInitManagement.originalAdTagUrl;
    this.#rmp.loadAds(this.#rmp.adTagUrl, ['internal']).catch(error => {
      this.#rmp.rmpUtils.warning(1020, error);
      this.#rmp.rmpUtils.playPromise();
    });
    this.#rmp.one('adloaded', this.#onAdLoadedAfterReload.bind(this));
  }

  setAdVolume(v) {
    let newVolume;
    if (v < 0) {
      newVolume = 0;
    } else if (v > 1) {
      newVolume = 1;
    } else {
      newVolume = v;
    }
    if (this.#rmp.imaAdsManager) {
      this.#rmp.imaAdsManager.setVolume(newVolume);
    } else if (this.#rmp.rmpVast) {
      this.#rmp.rmpVast.volume = newVolume;
    }
  }

  setAdMute(muted) {
    if (muted) {
      if (this.#rmp.imaAdsManager) {
        this.setAdVolume(0);
      } else if (this.#rmp.rmpVast) {
        this.#rmp.rmpVast.muted = true;
      }
    } else {
      let currentVolume = this.#rmp.volume;
      if (currentVolume < 0 || currentVolume > 1) {
        return;
      }
      if (this.#rmp.imaAdsManager) {
        if (currentVolume === 0) {
          currentVolume = this.#rmp.volumeBeforeMute;
        }
        this.setAdVolume(currentVolume);
      } else if (this.#rmp.rmpVast) {
        this.#rmp.rmpVast.muted = false;
        if (currentVolume === 0) {
          currentVolume = this.#rmp.volumeBeforeMute;
          this.setAdVolume(currentVolume);
        }
      }
    }
  }

  replaceAdTagVar(inputAdTag) {
    let adTag = inputAdTag;
    const varPattern = /__.+__/i;
    if (!varPattern.test(adTag)) {
      return adTag;
    }
    const supportedAdTagVar = [
      '__domain__',
      '__player-width__',
      '__player-height__',
      '__random-number__',
      '__page-url__',
      '__timestamp__',
      '__referrer__',
      '__mobile__',
      '__ima__',
      '__item-title__',
      '__item-description__',
      '__item-duration__',
      '__current-time__',
      '__device-ua__',
      '__language__', // it
      '__autoplay__', // auto|click
      '__muted__' // 1|0 - muted === 1
    ];
    if (typeof window.__tcfapi !== 'undefined') {
      supportedAdTagVar.push('__gdpr__');
      supportedAdTagVar.push('__gdpr-consent__');
    }
    if (typeof window.__uspapi !== 'undefined') {
      supportedAdTagVar.push('__uspdata__');
    }
    const valuesAdTagVar = [];
    // __domain__
    let domain = '';
    if (typeof location !== 'undefined' && location.hostname) {
      domain = (location.hostname).toLowerCase();
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(domain));
    const playerSize = this.#rmp.getPlayerSize();
    // __player-width__
    let playerWidth = playerSize.width;
    if (playerWidth <= 0) {
      playerWidth = '';
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent((Math.round(playerWidth)).toString()));
    // __player-height__
    let playerHeight = playerSize.height;
    if (playerHeight <= 0) {
      playerHeight = '';
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent((Math.round(playerHeight)).toString()));
    // __random-number__
    let randomNumber = '';
    for (let i = 0, len = 12; i < len; i++) {
      randomNumber += (FW.getRandomInt(0, 9)).toString();
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(randomNumber));
    // __page-url__
    let pageUrl = '';
    if (document.URL) {
      pageUrl = document.URL;
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(pageUrl));
    // __timestamp__
    let timestamp = Date.now();
    if (typeof timestamp !== 'number' || timestamp <= 0) {
      timestamp = '';
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(timestamp.toString()));
    // __referrer__
    let referrer = '';
    if (document.referrer) {
      referrer = document.referrer;
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(referrer));
    // __mobile__
    let mobile = '';
    if (this.#rmp.isMobile) {
      mobile = 'mobile';
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(mobile));
    // __ima__
    let ima = '';
    if (this.#rmp.adParser === 'ima') {
      ima = this.#rmp.adParser;
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(ima));
    // '__item-title__'
    let contentTitle = '';
    if (this.#rmp.contentMetadata.title !== '') {
      contentTitle = this.#rmp.contentMetadata.title;
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(contentTitle));
    // '__item-description__'
    let description = '';
    if (this.#rmp.contentMetadata.description !== '') {
      description = this.#rmp.contentMetadata.description;
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(description));
    // '__item-duration__'
    let duration = this.#rmp.duration;
    if (duration < 0 || !this.#rmp.isVod) {
      duration = '';
    } else {
      duration = (Math.round(duration / 1000)).toString();
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(duration));
    // '__current-time__'
    let currentTime = this.#rmp.currentTime;
    if (currentTime === -1 || !this.#rmp.isVod) {
      currentTime = '';
    } else {
      currentTime = (Math.round(currentTime / 1000)).toString();
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(currentTime));
    // __device-ua__
    let userAgent = '';
    if (Env.userAgent && Env.userAgent !== 'null') {
      userAgent = Env.userAgent;
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(userAgent));
    // __language__  ISO 639-1 (two-letter)
    let lng = window.navigator.languages[0];
    if (lng.length > 1) {
      lng = lng.substring(0, 2);
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(lng));
    // __autoplay__
    let autoplay = 'auto';
    if (this.#rmp.autoplayMode === 'no-autoplay' || this.#rmp.autoplayMode === 'unresolved') {
      autoplay = 'click';
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(autoplay));
    // __muted__
    let muted = '0';
    if (this.#rmp.mute || this.#rmp.volume <= 0) {
      muted = '1';
    }
    valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(muted));
    if (typeof window.__tcfapi !== 'undefined') {
      // __gdpr__
      valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(window.rmpGlobals.TCFv2.gdprApplies));
      // __gdpr-consent__
      valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(window.rmpGlobals.TCFv2.tcString));
    }
    if (typeof window.__uspapi !== 'undefined') {
      // __uspdata__
      valuesAdTagVar.push(AdsHelpers.rfc3986EncodeURIComponent(window.rmpGlobals.USPData));
    }
    supportedAdTagVar.forEach((value, index) => {
      adTag = adTag.replace(value, valuesAdTagVar[index]);
    });
    return adTag.trim();
  }

  endedOutStreamUI() {
    Logger.print('outstream', 'endedOutStreamUI');
    if (this.#rmp.contentMetadata.endOfVideoPoster.length > 0) {
      this.#rmp.endOfVideoPoster = FW.getPoster(this.#rmp.contentMetadata.endOfVideoPoster);
    }
    if (this.#rmp.endOfVideoPoster !== '') {
      this.#rmp.poster = this.#rmp.endOfVideoPoster;
    }
    if (this.#rmp.posterUri !== '') {
      this.#rmp.showPoster();
    }
    if (this.#rmp.dom.controlBar) {
      this.#rmp.dom.controlBar.classList.add('rmp-no-display');
    }
    this.#rmp.rmpUIManagement.showCentralPlay();
    // ad blocker detected >> do like ad parser 
    if (this.#rmp.adTagReloadOnEnded && !this.#rmp.adParserLoadError) {
      this.#onInteractionReloadAdTagFn = this.#onInteractionReloadAdTag.bind(this);
      if (this.#rmp.isMobile) {
        this.#rmp.dom.centralMobileUIIcon.classList.remove('rmp-i-pause', 'rmp-i-play');
        this.#rmp.dom.centralMobileUIIcon.classList.add('rmp-i-replay');
        FW.addEvents(['touchend', 'click'], this.#rmp.dom.centralMobileUI, this.#onInteractionReloadAdTagFn);
      } else {
        this.#rmp.dom.overlayButtonIcon.classList.replace('rmp-i-play', 'rmp-i-replay');
        FW.addEvents(['touchend', 'click'], this.#rmp.dom.overlayButton, this.#onInteractionReloadAdTagFn);
        this.#rmp.dom.container.addEventListener('click', this.#onInteractionReloadAdTagFn);
      }
    } else {
      FW.removeEvents(['touchend', 'click'], this.#rmp.dom.playPause, this.#rmp.initiatePlayback);
      if (this.#rmp.isMobile) {
        FW.removeEvents(['touchend', 'click'], this.#rmp.dom.centralMobileUI, this.#rmp.initiatePlayback);
      } else {
        FW.removeEvents(['touchend', 'click'], this.#rmp.dom.overlayButton, this.#rmp.initiatePlayback);
      }
      // in case adblocker detected prevent click on container to trigger play when adTagReloadOnEnded === true
      if (this.#rmp.adParserLoadError) {
        this.#rmp.rmpPlaybackManagement.playerInitialized = true;
      }
    }
  }

  seekToOffsetStartPosition() {
    const currentTime = this.#rmp.currentTime;
    if (currentTime < 100) {
      this.#rmp.seekTo(this.#rmp.offsetStartPosition).catch(error => {
        this.#rmp.rmpUtils.warning(1016, error);
      });
    }
    this.#rmp.offsetStartPosition = 0;
  }

  createControlBarAdInfo() {
    this.#rmp.dom.adInfo = FW.createElement('div', 'rmp-ad-info');
    if (!this.#rmp.adOutStream) {
      FW.hide(this.#rmp.dom.adInfo);
    }
    /*if (this.#rmp.isMobile && this.#rmp.adParser === 'ima' && this.#rmp.skin === 's2') {
      this.#rmp.dom.adInfo.classList.add('rmp-no-display');
    }*/
    this.#rmp.dom.controlBar.appendChild(this.#rmp.dom.adInfo);
    if (this.#rmp.labels.ads.controlBarCustomMessage !== '') {
      this.#rmp.dom.adMessage = FW.createElement('span', 'rmp-ad-info-message', this.#rmp.labels.ads.controlBarCustomMessage, this.#rmp.rtl);
      this.#rmp.dom.adInfo.appendChild(this.#rmp.dom.adMessage);
    }
  }

  setUIForAds(adUI) {
    Logger.print('advertisement', 'setUIForAds to ' + adUI);
    const labels = this.#rmp.labels;
    if (adUI && !this.#rmp.hasAdUI) {
      this.#rmp.dom.container.classList.add('rmp-linear-ad-ui');
      FW.hide(this.#rmp.dom.moduleArea);
      if (!this.#rmp.adOutStream) {
        this.#rmp.rmpModuleManagement.closeAll();
        if (this.#rmp.audioOnlyUseVideoLayout) {
          this.#rmp.dom.container.classList.remove('rmp-audio-only-use-video-layout');
        }
        if (this.#rmp.playlistAudioOnly) {
          this.#rmp.dom.container.classList.remove('rmp-playlist-audio-only');
        }
        if (this.#rmp.relatedAudioOnly) {
          this.#rmp.dom.container.classList.remove('rmp-related-audio-only');
        }
        if (this.#rmp.video360) {
          const uiText360 = this.#rmp.dom.container.querySelector('.rmp-360-text');
          if (uiText360) {
            FW.removeElement(uiText360);
          }
          FW.show(this.#rmp.dom.adContainer);
        }
      }
      // for SSAI adInfo is not created - e.g. _onImaAvailable is not called - create it then
      if (!this.#rmp.dom.adInfo) {
        this.createControlBarAdInfo();
      }
      if (!(this.#rmp.adCountDown === false && labels.ads.controlBarCustomMessage === '')) {
        FW.show(this.#rmp.dom.adInfo);
      }
      // in case linear change event
      if (this.#rmp.isVPAID) {
        this.#setVPAIDUI(true);
      }
      this.#handleFullSlotAdSense();
      this.#rmp.hasAdUI = true;
    } else if (!adUI && this.#rmp.hasAdUI) {
      this.#rmp.dom.container.classList.remove('rmp-linear-ad-ui');
      FW.showFlex(this.#rmp.dom.moduleArea);
      if (!this.#rmp.adOutStream) {
        this.#rmp.rmpModuleManagement.closeAll();
        if ((this.#rmp.isDvr && this.#rmp.isDvrLiveMode) || typeof this.#rmp.dom.seekBar === 'undefined') {
          FW.setText(this.#rmp.dom.timeElapsedText, labels.hint.live);
        }
        if (this.#rmp.audioOnlyUseVideoLayout) {
          this.#rmp.dom.container.classList.add('rmp-audio-only-use-video-layout');
        }
        if (this.#rmp.playlistAudioOnly) {
          this.#rmp.dom.container.classList.add('rmp-playlist-audio-only');
        }
        if (this.#rmp.relatedAudioOnly) {
          this.#rmp.dom.container.classList.add('rmp-related-audio-only');
        }
        if (this.#rmp.video360) {
          FW.hide(this.#rmp.dom.adContainer);
        }
      }
      FW.hide(this.#rmp.dom.adInfo);
      // remaining time bar
      if (this.#rmp.adShowRemainingTime) {
        FW.hide(this.#rmp.dom.adCurrentTime);
      }
      this.clearAdRemainingTimeBarInterval();
      // for VPAID ads because we hide central UI
      if (this.#rmp.isVPAID) {
        this.#setVPAIDUI(false);
      }
      // for fullslot adsense and VPAID we restore control bar visibility
      this.#rmp.dom.container.classList.remove('rmp-ad-no-ui');
      this.#rmp.hasAdUI = false;
    }
  }

  updateVPAIDStatus(adLinear) {
    if (/\/javascript/i.test(this.#rmp.adContentType)) {
      Logger.print('advertisement', 'VPAID ad detected');
      this.#rmp.isVPAID = true;
      if (adLinear) {
        this.#setVPAIDUI(true);
      }
    }
  }

  udpatePlayPause() {
    if (this.#rmp.adPaused) {
      this.#rmp.dom.playPause.classList.replace('rmp-i-pause', 'rmp-i-play');
      FW.setText(this.#rmp.dom.playPauseHint, this.#rmp.labels.hint.play + ' (k)');
      this.#rmp.rmpModuleManagement.updatePlayPauseUI(true);
      if (this.#rmp.isMobile) {
        this.#rmp.dom.centralMobileUIIcon.classList.replace('rmp-i-pause', 'rmp-i-play');
      }
      this.#rmp.rmpUIManagement.showCentralPlay();
    } else {
      this.#rmp.dom.playPause.classList.replace('rmp-i-play', 'rmp-i-pause');
      FW.setText(this.#rmp.dom.playPauseHint, this.#rmp.labels.hint.pause + ' (k)');
      this.#rmp.rmpModuleManagement.updatePlayPauseUI(false);
      if (this.#rmp.isMobile) {
        this.#rmp.dom.centralMobileUIIcon.classList.replace('rmp-i-play', 'rmp-i-pause');
      }
      this.#rmp.rmpUIManagement.hideCentralPlay();
    }
  }

  #adCountdownIntervalCallabck() {
    let timeRemaining = -1;
    if (this.#rmp.hlsJS &&
      this.#rmp.hlsJS.interstitialsManager &&
      this.#rmp.hlsJS.interstitialsManager.interstitialPlayer &&
      this.#rmp.interstitialShowAdUI) {
      const interstitialPlayer = this.#rmp.hlsJS.interstitialsManager.interstitialPlayer;
      // Is the interstitialPlayer playing an asset?
      if (interstitialPlayer && interstitialPlayer.playingIndex > -1) {
        timeRemaining = Math.ceil(
          interstitialPlayer.duration - interstitialPlayer.currentTime,
        );
      }
    } else if (this.#rmp.imaAdsManager) {
      timeRemaining = this.#rmp.imaAdsManager.getRemainingTime();
    } else if (this.#rmp.rmpVast) {
      timeRemaining = (this.#rmp.adDuration - this.#rmp.adCurrentTime) / 1000;
    } else if (this.#rmp.shakaAdManager && this.#rmp.shakaAd) {
      timeRemaining = this.#rmp.shakaAd.getRemainingTime();
    }
    if (typeof timeRemaining === 'number' && timeRemaining >= 0) {
      timeRemaining = FW.readableTime(timeRemaining);
      FW.setText(this.#rmp.dom.adCountdown, timeRemaining);
    }
  }

  addCountDown() {
    if (!this.#rmp.dom.adCountdown) {
      this.#rmp.dom.adCountdown = FW.createElement('span', 'rmp-ad-info-countdown');
      this.#rmp.dom.adInfo.appendChild(this.#rmp.dom.adCountdown);
    }
    this.#adCountdownIntervalCallabck();
    this.#adCountdownInterval = window.setInterval(this.#adCountdownIntervalCallabck.bind(this), 1000);
  }

  createAdMarkers(arrayMarkers, duration) {
    Logger.print('advertisement', 'createAdMarkers now');
    // this is for MPEG-DASH where there is an unknown race condition that makes timetotal/handle not defined yet
    if (typeof this.#rmp.dom.timetotal === 'undefined' || typeof this.#rmp.dom.handle === 'undefined') {
      setTimeout(() => {
        this.createAdMarkers(arrayMarkers, duration);
      }, 100);
      return;
    }
    if (this.#rmp.dom.timetotal && this.#rmp.dom.handle) {
      for (let i = 0; i < arrayMarkers.length; i++) {
        Logger.print('advertisement', i);
        const marker = FW.createElement('div', 'rmp-ad-markers');
        let markerValue;
        if (arrayMarkers[i] === Infinity) {
          markerValue = duration;
          marker.classList.add('rmp-ad-markers-postroll');
        } else {
          const percentMarker = arrayMarkers[i] * 100 / duration;
          if (percentMarker >= 100) {
            continue;
          }
          markerValue = arrayMarkers[i];
          if (markerValue === 0 || percentMarker < 3) {
            marker.classList.add('rmp-ad-markers-preroll');
          } else if (percentMarker > 97) {
            marker.classList.add('rmp-ad-markers-postroll');
          }
          marker.style.left = percentMarker + '%';
        }
        marker.setAttribute('data-marker-timestamp', markerValue);
        FW.insertBefore(this.#rmp.dom.timetotal, marker, this.#rmp.dom.handle);
      }
    }
  }

  clearAdMarkers() {
    if (this.#rmp.dom.timetotal) {
      const adMarkers = this.#rmp.dom.timetotal.querySelectorAll('.rmp-ad-markers');
      if (adMarkers.length > 0) {
        adMarkers.forEach(adMarker => {
          this.#rmp.dom.timetotal.removeChild(adMarker);
        });
      }
    }
  }

  #adRemainingTimeBar() {
    let remainingTime = -1;
    let adDuration = this.#rmp.adDuration;
    if (this.#rmp.hlsJS &&
      this.#rmp.hlsJS.interstitialsManager &&
      this.#rmp.hlsJS.interstitialsManager.interstitialPlayer &&
      this.#rmp.interstitialShowAdUI) {
      const interstitialPlayer = this.#rmp.hlsJS.interstitialsManager.interstitialPlayer;
      // Is the interstitialPlayer playing an asset?
      adDuration = interstitialPlayer.duration * 1000;
      if (interstitialPlayer && interstitialPlayer.playingIndex > -1) {
        remainingTime = Math.ceil(
          interstitialPlayer.duration - interstitialPlayer.currentTime,
        );
      }
    } else if (this.#rmp.imaAdsManager) {
      remainingTime = this.#rmp.imaAdsManager.getRemainingTime();
    } else if (this.#rmp.rmpVast) {
      const rmpVastRemainingTime = this.#rmp.rmpVast.adRemainingTime;
      if (rmpVastRemainingTime > -1) {
        remainingTime = rmpVastRemainingTime / 1000;
      }
    } else if (this.#rmp.shakaAdManager && this.#rmp.shakaAd) {
      remainingTime = this.#rmp.shakaAd.getRemainingTime();
    }
    if (DEBUG) {
      if (this.#rmp.debugLevel === 2) {
        Logger.print(`advertisement`,
          `adShowRemainingTime is true - remainingTime (ms): ${remainingTime * 1000} - adDuration (ms): ${adDuration}`);
      }
    }
    if (remainingTime > 0 && adDuration > 0) {
      let percent = Math.floor((1 - ((remainingTime * 1000) / adDuration)) * 100);
      if (percent < 0) {
        percent = 0;
      }
      this.#rmp.dom.adCurrentTime.style.width = percent + '%';
    }
  }

  appendRemainingTimeBar() {
    if (!this.#rmp.dom.adCurrentTime) {
      this.#rmp.dom.adCurrentTime = FW.createElement('div', 'rmp-ad-current-time');
      this.#rmp.dom.controlBar.appendChild(this.#rmp.dom.adCurrentTime);
    }
    FW.show(this.#rmp.dom.adCurrentTime);
    this.#rmp.dom.adCurrentTime.style.width = 0;
    this.#adRemainingTimeBar();
    this.clearAdRemainingTimeBarInterval();
    this.#adRemainingTimeBarInterval = window.setInterval(this.#adRemainingTimeBar.bind(this), 400);
  }

  clearAdRemainingTimeBarInterval() {
    window.clearInterval(this.#adRemainingTimeBarInterval);
  }

  destroy() {
    window.clearInterval(this.#adCountdownInterval);
    this.clearAdRemainingTimeBarInterval();
    if (this.#rmp.rmpAdScheduler) {
      this.#rmp.rmpAdScheduler.destroy();
    }
    if (this.#rmp.rmpApiSrc) {
      this.#rmp.rmpApiSrc.clear();
    }
  }

}
